import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class PhoneVerificationService {
  private apiUrl = environment.apiUrl;
  private getAccountByPhoneUrl = `${this.apiUrl}origination/originations/exists-account-by-phone/{phoneNumber}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public existsByPhone(phoneNumber: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(this.getAccountByPhoneUrl.replace('{phoneNumber}', phoneNumber), {
      headers: this.headers,
    });
  }
}
